module.exports = __webpack_public_path__ + "media/images/svg/trash-de967fe7fb57c631bcefe40cd5c4feec.svg";